module.exports = "<svg id=\"i-link\" viewBox=\"0 0 32 32\" width=\"32\" height=\"32\" fill=\"none\" stroke=\"currentcolor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"6.25%\">\n  <path d=\"M18 8 C18 8 24 2 27 5 30 8 29 12 24 16 19 20 16 21 14 17 M14 24 C14 24 8 30 5 27 2 24 3 20 8 16 13 12 16 11 18 15\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/svg/link.svg
// module id = 16
// module chunks = 0